import React, { useState, useRef } from 'react';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";

import styles from "assets/jss/material-kit-react/views/loginPage.js";

import image from "assets/img/bg7.jpg";
import Axios from "axios";
import Config from "../../config.js"
import swal from 'sweetalert'
var md5 = require('md5');
const useStyles = makeStyles(styles);

export default function LoginPage(props) {
  const { ...rest } = props;
  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  setTimeout(function () {
    setCardAnimation("");
  }, 700);
  const classes = useStyles();
  const inputPhoneNumber = useRef(null)
  const inputPassword = useRef(null)
  var onEnterPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      SignIn();
    }
  }
  
  var SignIn = () => {
    var PhoneNumber = inputPhoneNumber.current.value
    var Password = md5(inputPassword.current.value)
    Axios.post(Config.api + "Authentication/SignIn", {
      phoneNumber: PhoneNumber,
      deviceName: Date.now()
    },
      {
        headers: {
          apikey: Config.apikey
        },
        auth: {
          username: PhoneNumber,
          password: Password
        }
      }).then(async (result) => {
        localStorage.setItem('token', result.data.data.token);
        localStorage.setItem('registered', result.data.data.me.registered);
        localStorage.setItem('level', result.data.data.me.level);
        if (result.data.data.me.registered) {
          props.history.push("/Profile");
          /*
          swal({
                      title: "ورود موفق!",
                      text: "نمایشگاه ایران ایتکس هم اکنون در حال برگزاری ست.",
                      icon: "success",
                      
                      buttons: {
                        expo: {
                          text: "ورود  به نمایشگاه",
                          value: 0,
                          visible: true,
                          className: "",
                          closeModal: true
                        },
                        event: {
                          text: "رویدادهای جانبی",
                          value: 1,
                          visible: true,
                          className: "",
                          closeModal: true,
                        },
                        profile: {
                          text: "پروفایل",
                          value: 2,
                          visible: true,
                          className: "",
                          closeModal: true,
                        }
                      }
                    }).then((e)=>{
                      if(e==0){
                        Go();
                      }else if(e==1){
                        props.history.push("/Expositions");
                      }else{
                          props.history.push("/Profile");
                      }
                    })*/
        }
        else
          props.history.push("/Complete");
      }).catch((err) => {
        if (err && err.response && err.response.status && err.response.status == 422)
          swal("کد وارد شده نادرست است");
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
          swal(err && err.response && err.response.data && err.response.data.message.pr);
        else swal("خطایی رخ داده است.")

      })
  }
  return (
    <div>
      <Header
        absolute
        color="transparent"
        rightLinks={<HeaderLinks />}
        {...rest}
      />
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: "url(" + image + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center"
        }}
      >
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={4}>
              <Card className={classes[cardAnimaton]}>
                <form className={classes.form}>
                  <CardHeader color="primary" className={classes.cardHeader}>
                    <h5>ورود با رمز ایستا</h5>
                  </CardHeader>
                  <CardBody>
                    <CustomInput
                      labelText="شماره موبایل..."
                      id="MobileNumber"
                      onKeyPress={onEnterPress}
                      formControlProps={{
                        fullWidth: true,


                      }}
                      inputProps={{
                        type: "tel",
                        inputRef: inputPhoneNumber,
                        endAdornment: (
                          <InputAdornment position="end">
                            <PhoneAndroidIcon className={classes.inputIconsColor} />
                          </InputAdornment>
                        )
                      }}
                    />
                    <CustomInput
                      labelText="کلمه عبور"
                      id="pass"
                      onKeyPress={onEnterPress}
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "password",
                        inputRef: inputPassword,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Icon className={classes.inputIconsColor}>
                              lock_outline
                            </Icon>
                          </InputAdornment>
                        ),
                        autoComplete: "off"
                      }}
                    />
                  </CardBody>
                  <CardFooter className={classes.cardFooter}>
                    <div className={classes.extra}>
                      <a className={classes.extraLink} href='SendCode'>
                        ورود با رمز پویا
                      </a>
                    </div>
                    <Button onClick={SignIn} color="success">
                      <ArrowBackIosIcon />
                    </Button>
                  </CardFooter>
                </form>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    </div>
  );
}
